import React from 'react'
import styles from './styles.module.css'

const BrideGroom = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.carIcon}>🚘</div>
        <h2 className={styles.mainTitle}>Трансфер для гостей</h2>
        <div className={styles.divider}></div>
      </div>

      <div className={styles.content}>
        <p className={styles.description}>
          В случае необходимости, вы можете воспользоваться организованным 
          трансфером до площадки празднования и обратно
        </p>

        <div className={styles.detailsCard}>
          <h3 className={styles.detailTitle}>Время и место сбора</h3>
          
          <div className={styles.locationInfo}>
            <div className={styles.locationItem}>
              <span className={styles.locationIcon}>📍</span>
              <div className={styles.locationDetails}>
                <strong>Парковка национальной библиотеки</strong>
                <span>сбор 14:10</span>
                <span>выезд 14:20</span>
              </div>
            </div>
            
            <div className={styles.driverInfo}>
              <div className={styles.driverItem}>
                <span className={styles.driverIcon}>📱</span>
                <div className={styles.driverDetails}>
                  <strong>Номер водителя:</strong>
                  <span className={styles.phonePlaceholder}>
                    будет добавлен ближе к дате
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Новая секция с Telegram кнопкой */}
        <div className={styles.telegramSection}>
          <div className={styles.telegramIcon}>📸</div>
          <h3 className={styles.telegramTitle}>Фото-группа в Telegram</h3>
          <p className={styles.telegramDescription}>
            Вступите в нашу группу, чтобы делиться фотографиями и впечатлениями со свадьбы!
          </p>
          <a 
            href="https://t.me/+06udaaXgD_g1OTEy" 
            target="_blank" 
            rel="noopener noreferrer"
            className={styles.telegramButton}
          >
            <span className={styles.telegramButtonIcon}>✈️</span>
            Присоединиться к группе
          </a>
          {/* <p className={styles.telegramNote}>
             в день свадьбы
          </p> */}
        </div>
      </div>
    </div>
  )
}

export default BrideGroom